
import { useEffect } from 'react';
import { useScheduleState } from "@/hooks/useScheduleState";
import { useScheduleActions } from "./useScheduleActions";

export const useSchedulePageState = () => {
  const {
    selectedDate,
    currentMonth,
    viewMode,
    weekDates,
    selectedCalendarId,
    setSelectedCalendarId,
    isLoading,
    classes,
    handleDateSelect,
    handleMonthChange,
    handlePrevious,
    handleNext,
    fetchClasses,
  } = useScheduleState();

  // Create a wrapper function that returns a Promise
  const fetchClassesPromise = async () => {
    return await fetchClasses();
  };

  const {
    // Dialog states
    addClassDialogOpen,
    setAddClassDialogOpen,
    selectedTime,
    
    // Action handlers
    handleSaveClass,
    handleAddClass,
  } = useScheduleActions(fetchClassesPromise);

  // Ensure classes are loaded when the component mounts
  useEffect(() => {
    fetchClasses();
  }, [fetchClasses]);

  return {
    selectedDate,
    currentMonth,
    viewMode,
    weekDates,
    selectedCalendarId,
    setSelectedCalendarId,
    classes,
    isLoading,
    handleDateSelect,
    handleMonthChange,
    handlePrevious,
    handleNext,
    
    // Class actions
    handleAddClass,
    
    // Data refresh (for manual refresh after operations like delete)
    fetchClasses,
    
    // Dialog state for passing to ScheduleDialogs
    dialogState: {
      addClassDialogOpen,
      setAddClassDialogOpen,
      selectedDate,
      selectedTime,
      handleSaveClass
    }
  };
};
